"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
exports.DpAssessmentTypeIcon = void 0;
var jsx_runtime_1 = require("react/jsx-runtime");
var Common_1 = require("../../Common");
var react_bootstrap_1 = require("react-bootstrap");
var react_i18next_1 = require("react-i18next");
var DpAssessmentTypeIcon_styled_1 = require("./DpAssessmentTypeIcon.styled");
var icons = {
    assessment: 'doc',
    journal: 'essay',
    handout: 'practice',
    diagnostic: 'diagnostic',
    practice: 'practice',
};
var DpAssessmentTypeIcon = function (_a) {
    var type = _a.type, _b = _a.variant, variant = _b === void 0 ? '' : _b, _c = _a.tooltip, tooltip = _c === void 0 ? true : _c, _d = _a.tabIndex, tabIndex = _d === void 0 ? 0 : _d;
    var t = (0, react_i18next_1.useTranslation)('common').t;
    // ------------------------------- Render
    return ((0, jsx_runtime_1.jsx)(DpAssessmentTypeIcon_styled_1.StyledAssessmentTypeIcon, { className: "assessment-type ".concat(variant), children: tooltip ? ((0, jsx_runtime_1.jsx)(react_bootstrap_1.OverlayTrigger, { trigger: ['focus', 'hover'], overlay: (0, jsx_runtime_1.jsx)(react_bootstrap_1.Tooltip, { id: "type-tooltip", placement: "top", role: "tooltip", children: t("DpAssessmentTypeIcon.".concat(type)) }), children: (0, jsx_runtime_1.jsx)("div", { tabIndex: tabIndex, className: "tooltip-icon", "aria-live": "polite", children: (0, jsx_runtime_1.jsx)(Common_1.Icon, { name: icons[type] }) }) })) : ((0, jsx_runtime_1.jsx)(Common_1.Icon, { name: icons[type] })) }));
};
exports.DpAssessmentTypeIcon = DpAssessmentTypeIcon;
exports.default = exports.DpAssessmentTypeIcon;
